import { createReducer, on } from '@ngrx/store';

import { SelectedRow } from '#types/grid';
import { InventoryInquiryResponseRow, InventoryItemDetailResponseRow } from '#types/inventory';

import * as InventoryActions from './inventory.actions';

export interface InventoryState {
  detail: {
    data: SelectedRow<InventoryInquiryResponseRow>;
  };
  lot: {
    data: SelectedRow<InventoryItemDetailResponseRow>;
  };
}

export const initialState: InventoryState = {
  detail: {
    data: null,
  },
  lot: {
    data: null,
  },
};

export const reducer = createReducer<InventoryState>(
  initialState,

  //
  // inventory / item detail
  //

  on(
    InventoryActions.ItemDetailInitialize,
    (state): InventoryState => ({
      ...state,
      detail: {
        ...state.detail,
      },
    })
  ),

  on(
    InventoryActions.ItemDetailSetData,
    (state, action): InventoryState => ({
      ...state,
      detail: {
        ...state.detail,
        data: { ...action.data },
      },
    })
  ),

  on(
    InventoryActions.ItemDetailClearData,
    (state): InventoryState => ({
      ...state,
      detail: {
        ...state.detail,
        data: null,
      },
    })
  ),

  //
  // inventory / lot detail
  //

  on(
    InventoryActions.LotDetailInitialize,
    (state): InventoryState => ({
      ...state,
      lot: {
        ...state.lot,
      },
    })
  ),

  on(
    InventoryActions.LotDetailSetData,
    (state, action): InventoryState => ({
      ...state,
      lot: {
        ...state.lot,
        data: { ...action.data },
      },
    })
  ),

  on(
    InventoryActions.LotDetailClearData,
    (state): InventoryState => ({
      ...state,
      lot: {
        ...state.lot,
        data: null,
      },
    })
  )
);
